import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Activities = () => {

	const settings = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 3,  // Show 3 cards at a time
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 3000,
		pauseOnHover: false,responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,  // Show 2 cards on medium screens
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,  // Show 1 card on smaller screens
					slidesToScroll: 1,
				},
			},
		],
	};

	const activities = [
		{
			id: 1,
			image: "/images/activity1.png",
			category: "Education",
			date: "01.01.2025",
			title: "Scholarships for Students",
			content: "Supporting students with scholarships to pursue their education. We believe in empowering the next generation through education."
		},
		{
			id: 2,
			image: "/images/activity2.png",
			category: "Health",
			date: "02.01.2025",
			title: "Medical Aid for Rural Areas",
			content: "Providing medical assistance to underprivileged communities, ensuring healthcare access to rural areas that lack proper facilities."
		},
		{
			id: 3,
			image: "/images/activity3.png",
			category: "Environment",
			date: "03.01.2025",
			title: "Tree Plantation Drives",
			content: "Contributing to environmental sustainability by planting trees in communities, combating deforestation, and enhancing the ecosystem."
		},
		{
			id: 4,
			image: "/images/activity4.png",
			category: "Community Development",
			date: "04.01.2025",
			title: "Skill Development for Youth",
			content: "Offering skill development programs for youth to equip them with the necessary tools for a brighter future and self-sufficiency."
		},
		{
			id: 5,
			image: "/images/activity5.png",
			category: "Women Empowerment",
			date: "05.01.2025",
			title: "Women’s Leadership Training",
			content: "Empowering women through leadership training programs, helping them become active leaders in their communities."
		},
		{
			id: 6,
			image: "/images/activity6.png",
			category: "Disaster Relief",
			date: "06.01.2025",
			title: "Flood Relief Support",
			content: "Providing relief materials, food, and medical supplies to areas affected by natural disasters like floods and landslides."
		}
	];

	return (
		<section className="lg:px-24 p-10 mb-8">
			<div className="mb-12">
				<p className="lg:text-lg text-sm">Latest Activities —</p>
				<h2 className="lg:text-3xl text-xl font-bold mt-2 font-serif">Find the popular updates</h2>
			</div>

			{/* Slider Component */}
			<Slider {...settings} className="pb-6 activityCaruselList">
				{activities.map((activity) => (
					<div className="bg-white rounded-lg overflow-hidden w-fit shadow-md" key={activity.id}>
						<div className="relative">
							<span className="absolute top-4 right-4 bg-gray-500 text-white px-3 py-1 rounded-lg">
								{activity.category}
							</span>
							<img src={activity.image} alt={activity.title} className="w-full h-44 object-cover" />
						</div>
						<div className="p-6">
							<span className="text-sm text-gray-500">{activity.date}</span>
							<h4 className="text-xl font-bold my-4">{activity.title}</h4>
							<p className="text-base text-gray-700">{activity.content}</p>
						</div>
					</div>
				))}
			</Slider>
		</section>
	);
};

export default Activities;
